import { ENGLISH_LEVEL_SHORT } from '../core/constants';

export const READ_CANDIDATES_LIST = 'FE_READ_CANDIDATES_LIST';

export const CREATE_CANDIDATE_OFFER = 'CREATE_CANDIDATE_OFFER';

export const UPDATE_CANDIDATE_OFFER_ATTACHMENTS = 'UPDATE_CANDIDATE_OFFER_ATTACHMENTS';

export const CREATE_CANDIDATE_APPLICATION = 'CREATE_CANDIDATE_APPLICATION';

export const CANDIDATES_ROUTE = '/candidates';

export const UNCONFIRMED_QUALIFICATION_LEVEL_TOOLTIP = 'Unconfirmed qualification level';

export enum CandidateStatus {
  DEFAULT = 'DEFAULT',
  TEMPORARY = 'TEMPORARY',
  CANDIDATE = 'CANDIDATE',
  INTERVIEW = 'INTERVIEW',
  OFFER = 'OFFER',
  ACCEPTED = 'ACCEPTED',
}

const ENGLISH_LEVEL_ALIAS = {
  BEGINNER: 'Beginner',
  ELEMENTARY: 'Elementary',
  INTERMEDIATE: 'Intermediate',
  UPPER_INTERMEDIATE: 'Upper Intermediate',
  ADVANCED: 'Advanced',
  PROFICIENCY: 'Proficiency',
};

export const ENGLISH_LEVEL_OPTIONS = {
  [ENGLISH_LEVEL_ALIAS.BEGINNER]: 'Beginner',
  [ENGLISH_LEVEL_ALIAS.ELEMENTARY]: 'Elementary',
  [ENGLISH_LEVEL_ALIAS.INTERMEDIATE]: 'Intermediate',
  [ENGLISH_LEVEL_ALIAS.UPPER_INTERMEDIATE]: 'Upper Intermediate',
  [ENGLISH_LEVEL_ALIAS.ADVANCED]: 'Advanced',
  [ENGLISH_LEVEL_ALIAS.PROFICIENCY]: 'Proficiency',
};

export const MAP_ENGLISH_LEVEL_TO_SHORT = {
  [ENGLISH_LEVEL_ALIAS.BEGINNER]: ENGLISH_LEVEL_SHORT.A1,
  [ENGLISH_LEVEL_ALIAS.ELEMENTARY]: ENGLISH_LEVEL_SHORT.A2,
  [ENGLISH_LEVEL_ALIAS.INTERMEDIATE]: ENGLISH_LEVEL_SHORT.B1,
  [ENGLISH_LEVEL_ALIAS.UPPER_INTERMEDIATE]: ENGLISH_LEVEL_SHORT.B2,
  [ENGLISH_LEVEL_ALIAS.ADVANCED]: ENGLISH_LEVEL_SHORT.C1,
  [ENGLISH_LEVEL_ALIAS.PROFICIENCY]: ENGLISH_LEVEL_SHORT.C2,
};
